<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="vx-flex vx-items-center vx-justify-between">
                <div>
                    <span class="vx-text-base vx-font-extrabold vx-text-slate-700 lg:vx-text-xl">Preferred Group</span>
                    <div class="vx-text-sm vx-text-slate-500">Limit Contacts to Preferred Group</div>
                </div>
                <vx-toggle v-model="model" size="lg"></vx-toggle>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxToggle } from '@voxie/frontend-components';

const model = defineModel();
</script>
